import { createSelector } from '@reduxjs/toolkit'

import { RootState } from 'modules/store'

const selectState = (x: RootState) => x.notificationsReducer

export const selectNotify = createSelector(selectState, (state) => state)
